import { create } from 'zustand';

import type { BloodReportSidebarStoreState } from './blood-report-sidebar-store.model';

export const useBloodReportSidebarStore = create<BloodReportSidebarStoreState>((set) => ({
  clickedSectionId: null,
  setClickedSectionId: (clickedSectionId) => set({ clickedSectionId }),
}));
